var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ButtonBase',_vm._g(_vm._b({staticClass:"button-close"},'ButtonBase',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",[_vm._v(_vm._s(_vm.$t('ui.close')))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }